import Progress from 'antd/lib/progress';
import * as React from 'react';
import { runwayColors, antGrey } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';

interface PercentCompleteComponentProps {
    workingBranchEnabled: boolean;
    percentComplete: number;
    appliedFiltersCount: number;
}

const PercentCompleteComponent: React.FC<PercentCompleteComponentProps> = (props: PercentCompleteComponentProps) => {
    return (
        <Progress
            type="circle"
            strokeColor={runwayColors.statusGreen}
            percent={props.percentComplete}
            format={(percent) => {
                return (
                    <div>
                        {percent}%
                        {props.appliedFiltersCount > 0 && (
                            <Text
                                style={{
                                    color: antGrey.grey7,
                                    fontSize: 11,
                                    alignItems: 'center',
                                    display: 'block',
                                    paddingTop: 4,
                                }}
                            >
                                {props.appliedFiltersCount} {props.appliedFiltersCount === 1 ? 'filter' : 'filters'}{' '}
                                applied
                            </Text>
                        )}
                    </div>
                );
            }}
        />
    );
};

export default PercentCompleteComponent;
